import { ApiResourceFactory } from '../api.resource.factory'
import { CommonHelper } from '../../../helpers/common-helper'
import {  GridModel, GridRequestModel, ResponseListModel, EntityModel } from '../api.models'

export interface IServicemansService {
    getServicemans( req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getAllServicemans(): ng.IPromise<ResponseListModel<Object>>
    getServiceman(id, state?: any): ng.IPromise<EntityModel>
}

export class ServicemansService implements IServicemansService {
    constructor(private apiResource: ApiResourceFactory) { }

    getServicemans(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.servicemans.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAllServicemans(state: any = {}) {
        var getAllServicemans = this.apiResource.servicemans['getAllServicemans']
        state.request = getAllServicemans()
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getServiceman(id, state: any = {}) {
        var get = this.apiResource.servicemans.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }
}
